




































import { Component, Vue } from "vue-property-decorator";
import { PatientFilter } from "@/store/modules/types";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import Pager from "@/components/Pager.vue";
import PatientSearch from "@/components/patient/PatientSearch.vue";
import PatientList from "@/components/patient/PatientList.vue";
import PatientLog from "@/components/patient/PatientLog.vue";
import PatientEditor from "@/components/patient/PatientEditor.vue";

@Component({
  components: {
    Header,
    EntityTabs,
    Pager,
    PatientSearch,
    PatientList,
    PatientLog,
    PatientEditor
  }
})
export default class Patients extends Vue {
  filter = this.defaultFilter();
  pageRows: Array<any> = [];
  totalRows: number = 0;
  selected: any | null = null;
  async getPatients() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch("patients/getList", this.filter);
      this.totalRows = data.totalRows;
      this.pageRows = data.pageRows;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  defaultFilter(): PatientFilter {
    return {
      firstName: "",
      lastName: "",
      insurerId: "",
      insurerMemberId: "",
      EMR_ID: "",
      withPhoneErrors: false,
      pageNumber: 1,
      rowsPerPage: 25
    };
  }
  clearFilter() {
    this.filter = this.defaultFilter();
    this.getPatients();
  }
  editPatient(patient) {
    if (!this.entitySelected()) return;
    this.selected = patient;
    this.$modal.show("patient-editor");
  }
  showLog(patient) {
    if (!this.entitySelected()) return;
    this.selected = patient;
    this.$modal.show("patient-log");
  }
  entitySelected(): boolean {
    if (this.$store.state.auth.entityId == 0) {
      this.$modal.show("dialog", {
        title: "PatientCare",
        text:
          "Please select an <span class='wm-fw-500'>area or division</span>."
      });
      return false;
    }
    return true;
  }
  rowsPerPageChanged(rowsPerPage: number) {
    this.filter.rowsPerPage = rowsPerPage;
    this.getPatients();
  }
  pageChanged(page: number) {
    this.filter.pageNumber = page;
    this.getPatients();
  }
  mounted() {
    this.getPatients();
  }
}
